/*
 * @Author: cc
 * @Date: 2020-12-04 18:38:44
 * @LastEditTime: 2021-01-04 14:31:47
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\app\pending\editCenterPendingRouter.js
 * @Description: 
 */
'use strict';
angular.module('editingCenterPendingRouterModule', []).config(['$stateProvider',
    function($stateProvider) {
        $stateProvider.state('front.editctr.app.pending', {
            url: '/pending?siteid&channelid&mediatype',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/app/pending/main_tpl.html',
                    controller: 'editingCenterPendingController'
                }
            }
        }).state('front.editctr.app.pending.pendingtimingSign', {
            url: '/pendingtimingsign',
            views: {
                'main@front.editctr': { // 由于不区分平台 故将待审平台的定时签发模块与待编平台公用
                    templateUrl: './editingCenter/app/toBeCompiled/timingSign/timingSign_tpl.html',
                    controller: 'editCompileTimingSignController'
                // templateUrl: './editingCenter/app/pending/timingSign/timingSign_tpl.html',
                // controller: 'editPendingTimingSignController'
                }
            }
        }).state('front.editctr.app.pending.myshare', {
            url: '/myshare',
            views: {
                'main@front.editctr': {
                    templateUrl: './editingCenter/iWo/myManuscript/myShare/myShare_tpl.html',
                    controller: 'myShareCtrl'
                }
            }
        });
    }
]);
